import { HttpErrorResponse } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { DataService } from "../../../data.service";
import { TrackInfoModel, TrackDataHistoryModel, ClientContactModel, ClientInfoModel, AuthUserModel } from "../../../model";
import { AuthService } from "../../../auth/auth.service";


@Component({
    selector: 'app-track-check',
    templateUrl: './track-check.component.html',
    styleUrls: ['./track-check.component.css'],
    standalone: false
})
export class TrackCheckComponent implements OnInit {
    user?: ClientInfoModel;
    authInfo?: AuthUserModel | null;
    trackNum: string = '';
    trackInfo: TrackInfoModel | undefined | null;
    trackHistory!: TrackDataHistoryModel[];
    showClientDialog: boolean = false;
    currentClientToView?: ClientContactModel;


    constructor(private dataService: DataService, public auth: AuthService) {
    }

    async ngOnInit() {
        this.user = await this.auth.userData();
        this.authInfo = await this.auth.authUser;
    }

    onKeyUp(event: KeyboardEvent) {
        if (event.code.endsWith('Enter')) {
            this.checkTrack();
        }
    }

    checkTrack() {
        const subscr = this.dataService.trackInfo(this.trackNum.trim()).subscribe({
            next: (result) => {
                if (result) {
                    this.trackInfo = result;
                    this.trackHistory = result['history'];
                } else {
                    this.trackInfo = null;
                }

                this.trackNum = '';
            },
            complete: () => {
                subscr.unsubscribe();
            },
            error: (err: HttpErrorResponse) => {
                subscr.unsubscribe();
                switch (err.message) {
                    case 'can_not_retreive_tracks':
                        alert("Данные не найдены");
                        return;

                    default:
                        alert(err.message);
                }
            }
        });

    }

    removeHistory(id: number) {
        if (this.trackInfo) {
            if (confirm("Внимание! Вы уверенны, что хотите удалить последний статус посылки?")) {
                this.dataService.removePackageHistory(id).subscribe((result: any) => {
                    this.trackNum = this.trackInfo?.tracknum ? this.trackInfo?.tracknum : '';
                    this.checkTrack();
                })
            }
        }
    }

    restoreTrack() {
        if (this.trackInfo) {
            if (confirm("Внимание! Вы уверенны, что хотите отменить удаление?")) {
                this.dataService.restoreTrack(this.trackInfo.id).subscribe((result: any) => {
                    this.trackNum = this.trackInfo?.tracknum ? this.trackInfo?.tracknum : '';
                    this.checkTrack();
                })
            }
        }
    }

    closeClientWnd() {
        this.showClientDialog = false;
        this.currentClientToView = undefined;
    }

    showClientWnd() {
        this.showClientDialog = true;
        if (this.trackInfo?.client_id) {
            this.dataService.clientInfoById(this.trackInfo?.client_id).subscribe((result: ClientContactModel) => {
                this.currentClientToView = result;
            });
        } else {
            this.currentClientToView = undefined;
        }
    }

}
